import { DarkCallout } from '@/components/brand-kit/dark-callout'
import type { VerifiedTool } from '@/lib/blog-tool-linker'

/**
 * In-content "Free tool" CTA — one per article, fed from
 * enrichmentData.tools[0] (verified implemented tools only), rendered in the
 * article flow after the FAQ section. Template injection only: article HTML
 * in the DB is never modified. Reuses the DarkCallout visual language of the
 * sidebar "Free tool" callout.
 */
export function ArticleToolCta({ tool }: { tool: VerifiedTool }) {
  return (
    <section style={{ marginTop: 40, maxWidth: 460 }} aria-label="Free tool">
      <DarkCallout
        variant="dark"
        eyebrow="Free tool"
        headline={tool.name}
        body="Free interactive tool from Fridge.com — get a quick answer while you read."
        href={tool.url}
        cta="Open the tool ↗"
      />
    </section>
  )
}
